import React from 'react';
import { useSelector } from "react-redux";
import { BodyRegular } from '@shared/ui/atoms/fonts/Body';
import { selectWhereaboutsOptionById } from '@features/whereabouts/store/whereaboutsOptions.duck';
import { WhereaboutsOption } from '@features/whereabouts/services/WhereaboutOptions';

interface Props {
  whereaboutsId?: number;
  fallbackLabel?: string;
}

// Renders the leave type name (e.g. "Holiday", "Sick Leave") as bold body text, resolved from the
// whereabouts option with a fallback (e.g. for Holiday). Used as the "Booking Type" line in Your Bookings.
export function LeaveTypeLabel(props: Props) {
  const option: WhereaboutsOption | undefined = useSelector(state => selectWhereaboutsOptionById(state, props.whereaboutsId ?? 0));

  const label = option?.label ?? props.fallbackLabel;

  if (!label) {
    return null;
  }

  return <BodyRegular weight={700}>{label}</BodyRegular>;
}
